import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { OnboardedGuardService } from './onboarded-guard.service';
import { PropertiesGuardService } from './properties-guard.service';

@Injectable()
export class PropertiesOrOnboardedGuardService {
  constructor(
    private onboardedGuard: OnboardedGuardService,
    private propertiesGuard: PropertiesGuardService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return combineLatest([
      this.onboardedGuard.canActivate(route, state, true),
      this.propertiesGuard.canActivate(route, state, true),
    ]).pipe(
      map(([onboarded, hasPropertiesSubscription]) => {
        let result = onboarded || hasPropertiesSubscription;
        if (!result) {
          this.router.navigate(['/onboarding']);
        }
        return result;
      })
    );
  }
}
